import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { isIdTarget } from '../../store/actions/todoActions';

import { useDispatch } from "react-redux";
import ConditionalRender from "../../components/Common/ConditionalRender";
import CountdownTimer from "../../components/Common/CountdownTimer";
import { formatRupiah, scrollToSection, useHandleClickLoading } from "../../components/Common/utils";

const FlashSaleSlider = ({ flashSaleData, flashSaleLoading, logicFlashsale }) => {
  const isProfile = localStorage.getItem("isProfile");
  const profileData = JSON.parse(isProfile);
  const isWebSetting = localStorage.getItem('isWebSetting');
  const parseWebSetting = JSON.parse(isWebSetting);
  const dispatch = useDispatch();
  const handleClickLoading = useHandleClickLoading();

  return (
    new Date(logicFlashsale.waktu_berakhir) > new Date(parseWebSetting?.datetime) &&
    <div className="flex flex-col py-3  shadow-inner rounded-none lg:rounded-lg  bg-cardLight dark:bg-cardDark">
      <div className="flex flex-col gap-3 px-3 w-full ">
        <div className="flex flex-row gap-3 items-end z-10 ">
        <div className="flex flex-row items-center w-full gap-2">
          <img
            src={require('../../assets/images/flashSaleRevyc.png')}
            alt={"logo"}
            className={`flex  h-20 w-28 object-contain -mt-8 -mb-8`}
          />
         <CountdownTimer type={2} expired={logicFlashsale.waktu_berakhir || new Date()} 
         onResponse={(a) => { }}/>
        </div>
        </div>
        <div className="relative xl:aspect-[7.5/1] lg:aspect-[6.2/1] md:h-40 sm:h-40 h-40 w-full">
          <div className="flex flex-col h-full w-full z-10 relative ">
            <ConditionalRender
              productsData={flashSaleData}
              isLoading={flashSaleLoading}
              model={"emptyData"}
            >
              <div className=" absolute top-0 left-0 bottom-0 right-0">
                <Swiper
                  className="w-full h-full "
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  spaceBetween={10}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    640: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                    1280: {
                      slidesPerView: 3,
                    },
                    1536: {
                      slidesPerView: 3,
                    },
                  }}
                  modules={[Autoplay]}
                >
                  {flashSaleData.map((item, index) => {
                    const selectedPriceLevel =
                      profileData?.level === "member"
                        ? item.harga
                        : profileData?.level === "silver"
                          ? item.harga_silver
                          : profileData?.level === "pro"
                            ? item.harga_pro
                            : profileData?.level === "gold"
                              ? item.harga_gold
                              : item.harga;
                    return (
                      // <SwiperSlide
                      //     key={index}
                      // >
                      //     <div className="flex flex-col flex-1 overflow-hidden rounded-lg rounded-tl-3xl rounded-br-3xl h-full gap-1 group cursor-pointer"
                      //         onClick={() => {
                      //             handleClickLoading('/beli/' + item.slug)
                      //         }}>
                      //         <div className="relative flex flex-col bg-[#2121210f] dark:bg-[#f3f3f30f] flex-1 h-full overflow-hidden aspect-square ">
                      //             <LazyLoadImage
                      //                 src={item.gambar}
                      //                 alt={item.nama}
                      //                 height={"100%"}
                      //                 className=" w-full h-full object-cover group-hover:blur-xl"
                      //                 effect="blur"
                      //             />
                      //             <div className="absolute w-full h-full hidden items-center justify-center group-hover:flex">
                      //                 <img
                      //                     src={parseWebSetting?.favicon}
                      //                     alt="Logo"
                      //                     width={'30%'}
                      //                     height={'30%'}
                      //                     className="white-filter"
                      //                 />
                      //             </div>
                      //         </div>
                      //     </div>
                      // </SwiperSlide>
                      <SwiperSlide
                        key={index}
                        className="flex flex-col rounded-lg bg-[#122f4e] group shadow-md "
                      >
                        <button
                          onClick={() => {
                            handleClickLoading('/beli/' + item.slug)
                            const { gambar, background, slug, ...filteredData } =
                              item;
                            dispatch(isIdTarget(filteredData));
                            setTimeout(() => {
                              scrollToSection("payment");
                            }, 1000);
                          }}
                          className="flex flex-1 flex-col h-full w-full gap-2">
                          <div className="flex relative flex-col w-full rounded-lg overflow-hidden aspect-square">
                            <LazyLoadImage
                              src={item.background}
                              alt={item.nama}
                              height={"100%"}
                              className="rounded-lg w-full h-full object-cover "
                              effect="blur"
                            />
                            <div className="bg-[#212121] absolute top-0 left-0 right-0 bottom-0 opacity-50" />
                            <div className="flex flex-row gap-2 absolute top-2 left-2 right-2 bottom-2 ">
                              <div className="flex flex-col gap-2 ">
                                <div className="relative flex overflow-hidden rounded-lg">
                                  <div className="flex relative flex-col group-hover:blur-lg  w-full rounded-lg  sm:h-28 h-20 aspect-square p-1 bg-[#ffffff78]">
                                    <LazyLoadImage
                                      src={item.gambar}
                                      alt={item.nama}
                                      height={"100%"}
                                      className="w-full h-full object-cover rounded-lg"
                                      effect="blur"
                                    />
                                  </div>
                                  <div className="absolute w-full h-full hidden items-center justify-center group-hover:flex">
                                    <img
                                      src={parseWebSetting?.favicon}
                                      alt="Logo"
                                      width={'50%'}
                                      height={'50%'}
                                      className="white-filter"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="flex flex-col w-full flex-1 justify-between items-start ">
                                <span className=" text-sm text-left text-darkColor line-clamp-1">
                                  {item.kategori}
                                </span>
                                <span className=" text-md text-left text-darkColor font-semibold flex-1 line-clamp-2">
                                  {item.layanan}
                                </span>
                                <div className="flex p-1 bg-[#41bb32] px-3 rounded-md mb-1">
                                  <span className=" text-sm text-left text-darkColor font-semibold  line-clamp-1">
                                    {formatRupiah(selectedPriceLevel)}
                                  </span>
                                </div>
                                <span className="text-xs text-left text-[#ff6161] line-through line-clamp-1">
                                  {formatRupiah(item.harga_diskon)}
                                </span>
                                <div className="flex sm:flex-none " />
                                <div className="bg-[#f3f3f36c] w-full rounded-l-3xl mt-2 rounded-r-lg relative">
                                  <div
                                    className=" rounded h-4 relative overflow-hidden"
                                    style={{
                                      width: `${item.stok && item.jumlah_stok
                                        ? (item.stok / item.jumlah_stok) * 100
                                        : 0
                                        }%`,
                                    }}
                                  >
                                    <div
                                      className="h-full  rounded-l-3xl rounded-r-lg "
                                      style={{
                                        backgroundImage:
                                          "url('https://sin1.contabostorage.com/b1d79b8bbee7475eab6c15cd3d13cd4d:nextopup/p/barfull.png')",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                    ></div>
                                  </div>
                                  <img
                                    src={
                                      "https://sin1.contabostorage.com/b1d79b8bbee7475eab6c15cd3d13cd4d:nextopup/p/fire.png"
                                    }
                                    alt={"fire"}
                                    className={`absolute  bottom-1 -top-1 -left-1 h-5`}
                                  />
                                  <span className="absolute right-0 bottom-0 left-0 text-xs font-bold text-darkColor  inline-block ">
                                    {item.stok} Stok
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <img
                            src={
                              "https://sin1.contabostorage.com/b1d79b8bbee7475eab6c15cd3d13cd4d:indoflazz/p/fs.gif"
                            }
                            alt={"logo"}
                            className={`h-[60%] w-[20%] absolute -top-2 right-0 object-cover z-10 `}
                          />
                        </button>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            </ConditionalRender>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FlashSaleSlider;